import SiteLayout from '@/components/feature/SiteLayout';
import PageHero from '@/components/feature/PageHero';
import CtaBanner from '@/components/feature/CtaBanner';
import CertificatesSection from '@/pages/home/components/CertificatesSection';
import AboutStory from '@/pages/about/components/AboutStory';
import AboutValues from '@/pages/about/components/AboutValues';
import AboutJourney from '@/pages/about/components/AboutJourney';
import AboutProcess from '@/pages/about/components/AboutProcess';
import AboutTeam from '@/pages/about/components/AboutTeam';
import { aboutHeroImage } from '@/mocks/aboutData';

export default function AboutPage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="About Us"
        title="Ayurvedic Medicine Manufacturers from Madurai, Tamil Nadu"
        description="Best Research Pharma blends traditional Ayurvedic wisdom with modern research to craft authentic, effective herbal medicines trusted across India."
        crumbs={[{ label: 'Home', to: '/' }, { label: 'About Us' }]}
        image={aboutHeroImage}
      />
      <AboutStory />
      <AboutValues />
      <AboutJourney />
      <CertificatesSection />
      <AboutProcess />
      <AboutTeam />
      <CtaBanner
        eyebrow="Work With Us"
        title="Become a Distributor of Authentic Ayurveda"
        description="Join our growing network of 300+ distributors across India and grow with a brand built on quality, consistency and trust."
        primary={{ label: 'Become a Distributor', to: '/#distributor-apply', icon: 'ri-hand-heart-line' }}
        secondary={{ label: 'Contact Us', to: '/contact', icon: 'ri-mail-send-line' }}
      />
    </SiteLayout>
  );
}